import React from 'react';
import { Quill } from 'react-quill';
import styled from 'styled-components';
import StyledToolTip from '../styledComponents/StyledToolTip';
import htmlEditButton from "quill-html-edit-button";
Quill.register("modules/htmlEditButton", htmlEditButton);
// Custom Undo button icon component for Quill editor. You can import it directly
// from 'quill/assets/icons/undo.svg' but I found that a number of loaders do not
// handle them correctly

// Undo and redo functions for Custom Toolbar
function undoChange() {
  this.quill.history.undo();
}

function redoChange() {
  this.quill.history.redo();
}

// Add sizes to whitelist and register them
const Size = Quill.import('formats/size');
Size.whitelist = ['extra-small', 'small', 'medium', 'large'];
Quill.register(Size, true);

const CustomUndo = () => (
  <svg viewBox="0 0 18 18">
    <polygon className="ql-fill ql-stroke" points="6 10 4 12 2 10 6 10" />
    <path
      className="ql-stroke"
      d="M8.09,13.91A4.6,4.6,0,0,0,9,14,5,5,0,1,0,4,9"
    />
  </svg>
);

// Redo button icon component for Quill editor
const CustomRedo = () => (
  <svg viewBox="0 0 18 18">
    <polygon className="ql-fill ql-stroke" points="12 10 14 12 16 10 12 10" />
    <path
      className="ql-stroke"
      d="M9.91,13.91A4.6,4.6,0,0,1,9,14a5,5,0,1,1,5-5"
    />
  </svg>
);

// Add fonts to whitelist and register them
const Font = Quill.import('formats/font');
Font.whitelist = [
  'arial',
  'comic-sans',
  'courier-new',
  'georgia',
  'helvetica',
  'lucida',
];
Quill.register(Font, true);

// Modules object for setting up the Quill editor
export const getModules = (id, hide) => {
  const modules = {
    toolbar: {
      container: `#${id || 'toolbar'}`,
      handlers: {
        undo: undoChange,
        redo: redoChange,
      },
    },
    history: {
      delay: 500,
      maxStack: 100,
      userOnly: true,
    },
  };

  // Conditionally add the htmlEditButton module if hide is false
  if (!hide) {
    modules.htmlEditButton = {
      msg: "Edit the content in HTML format", // Custom message
      okText: "Save",
      cancelText: "Cancel",
      buttonHTML: "HTML",
      buttonTitle: "Show HTML source",
      syntax: false,
      prependSelector: "div#myelement",
      editorModules: {},
    };
  }

  return modules;
};


// Formats objects for setting up the Quill editor
export const formats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'align',
  'strike',
  'script',
  'blockquote',
  'background',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
  'color',
  'clean',
];


// Quill Toolbar component
export const QuillToolbar = ({ id, noToolBar,hide }) => (
  
    <StyledToolBar>
      <div id={`${id || 'toolbar'}`} className={`d-flex ${noToolBar && 'd-none'}`}>
        <div className="ql-formats d-flex me-0 toolbar-flex">
          <StyledToolTip title="Bold" childrenClass={'ms-0'}>
            <button className="ql-bold" />
          </StyledToolTip>
          <StyledToolTip title="Italic" childrenClass={'ms-0'}>
            <button className="ql-italic" />
          </StyledToolTip>
          <StyledToolTip title="Underline" childrenClass={'ms-0'}>
            <button className="ql-underline" />
          </StyledToolTip>
          <StyledToolTip title="Paragraph" childrenClass={'ms-0'}>
            <button className="ql-direction" value="rtl" />
          </StyledToolTip>
          <StyledToolTip title="Numbered list" childrenClass={'ms-0'}>
            <button className="ql-list" value="ordered" />
          </StyledToolTip>
          <StyledToolTip title="Bullet points" childrenClass={'ms-0'}>
            <button className="ql-list" value="bullet" />
          </StyledToolTip>
          <StyledToolTip title="Align left" childrenClass={'ms-0'}>
            <button className="ql-align" value="" />
          </StyledToolTip>
          <StyledToolTip title="Align Center" childrenClass={'ms-0'}>
            <button className="ql-align" value="center" />
          </StyledToolTip>
          <StyledToolTip title="Align right" childrenClass={'ms-0'}>
            <button className="ql-align" value="right" />
          </StyledToolTip>
          <StyledToolTip title="Justify" childrenClass={'ms-0'}>
            <button className="ql-align" value="justify" />
          </StyledToolTip>
          <StyledToolTip title="Insert/edit link" childrenClass={'ms-0'}>
            <button className="ql-link" />
          </StyledToolTip>
          <StyledToolTip title="Insert image" childrenClass={'ms-0'}>
            <button className="ql-image d-none" />
          </StyledToolTip>
          <StyledToolTip title="Insert video" childrenClass={'ms-0'}>
            <button className="ql-video d-none" />
          </StyledToolTip>
          <StyledToolTip title="Undo" childrenClass={'ms-0'}>
            <button className="ql-undo">
              <CustomUndo />
            </button>
          </StyledToolTip>
          <StyledToolTip title="Redo" childrenClass={'ms-0'}>
            <button className="ql-redo">
              <CustomRedo />
            </button>
          </StyledToolTip>
          <StyledToolTip title="Block" childrenClass={'ms-0'}>
            <button className="code-block" />
          </StyledToolTip>
         <StyledToolTip title="Size" childrenClass={`ms-0 ${hide ? '' : 'd-none'}`}>
            <select className="ql-size">
              <option value="small" />
              <option value="medium" defaultValue />
              <option value="large" />
            </select>
          </StyledToolTip>
          <StyledToolTip title="Text Color" childrenClass={`ms-0 ${hide ? '' : 'd-none'}`}>
            <select className="ql-color" />
          </StyledToolTip>
        </div>
      </div>
    </StyledToolBar>
    
);
const StyledToolBar = styled.div`
  ${props => props.theme.sm} {
    .toolbar-flex {
      .ql-link,
      .ql-code-block,
      .ql-direction,
      .ql-align {
        display: none;
      }
    }
  }
`;

export default QuillToolbar;
